// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1gcVW","label":"Labeled_label__39b1S","divider":"Labeled_divider__1O1CA"};